const message = {
  fr: 'C\'est un message de test',
  de: 'Dies ist eine Testmeldung',
  en: 'This is a test message'
};

export default class FakeInformationMessageService {
  getInformationMessage() {
    return new Promise(resolve => setTimeout(() => resolve(message), 0));
  }
}
